import {
    ADD_RETAILER_FAILED, ADD_RETAILER_LOADING, ADD_RETAILER_SUCCESS,
    GET_ALLRETAILER_REMOVE
} from "../types";

const initialState = {
    loading: false,
    error: null,
    Retailer: null,
    status: null,
};

export const addRetailerReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any }
) => {
    switch (action.type) {
        case ADD_RETAILER_LOADING:
            return {
                ...state,
                loading: action.loading,
            };
        case ADD_RETAILER_SUCCESS:
            return {
                ...state,
                loading: false,
                Retailer: action.payload,
                status: action.status,
                error: null,
            };
        case ADD_RETAILER_FAILED:
            return {
                ...state,
                loading: false,
                Retailer: null,
                status: null,
                error: action.error,
            };
        case GET_ALLRETAILER_REMOVE:
            return initialState;
        default:
            return state;
    }
};
